import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useProfile } from "@/hooks/useProfile";

export function hasLivePlanDay(rows: Array<{ status: string; plan_origin: string | null }>): boolean {
  return rows.some((row) => row.plan_origin !== null && row.status !== "cancelled");
}

/** O pet já vem nesta data pelo plano? Aí a Nova reserva não cria outra diária. */
export function usePlanDayOnDate({ petId, date, enabled }: { petId: string | null; date: string; enabled: boolean }) {
  const { data: profile } = useProfile();
  const clinicId = profile?.current_clinic_id ?? null;
  return useQuery({
    queryKey: ["daycare-hotel", "plan-day-on-date", clinicId, petId, date],
    enabled: enabled && Boolean(clinicId && petId && date),
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase as any)
        .from("stay_reservation_days")
        .select("status, plan_origin")
        .eq("clinic_id", clinicId)
        .eq("pet_id", petId)
        .eq("stay_date", date);
      if (error) throw error;
      return hasLivePlanDay((data ?? []) as Array<{ status: string; plan_origin: string | null }>);
    },
  });
}
